export const notificationTypes = Object.freeze({
  ALL_NEW_ORDER: "all_new_order",
  HOTEL_NEW_ORDER: "hotel_new_order",
  CAR_NEW_ORDER: "car_new_order",
  RAIL_NEW_ORDER: "rail_new_order",
  FLIGHT_NEW_ORDER: "flight_new_order",
  LOW_COST_NEW_ORDER: "low_cost_new_order",
  OTHER_NEW_ORDER: "other_new_order",
  INSURANCE_NEW_ORDER: "insurance_new_order",
  ALL_REMIND_WNT: "all_remind_wnt",
  HOTEL_REMIND_WNT: "hotel_remind_wnt",
  CAR_REMIND_WNT: "car_remind_wnt",
  RAIL_REMIND_WNT: "rail_remind_wnt",
  FLIGHT_REMIND_WNT: "flight_remind_wnt",
  LOW_COST_REMIND_WNT: "low_cost_remind_wnt",
  OTHER_REMIND_WNT: "other_remind_wnt",
  INSURANCE_REMIND_WNT: "insurance_remind_wnt"
});

export const notificationTypeNames = function() {
  return [
    {
      text: "Wszystkie nowe zamówienia",
      value: notificationTypes.ALL_NEW_ORDER,
      dates: false
    },
    {
      text: "Nowe zamówienia hotelowe",
      value: notificationTypes.HOTEL_NEW_ORDER,
      dates: false
    },
    {
      text: "Nowe zamówienia dot. wypożyczenia samochodu",
      value: notificationTypes.CAR_NEW_ORDER,
      dates: false
    },
    {
      text: "Nowe zamówienia biletów kolejowych",
      value: notificationTypes.RAIL_NEW_ORDER,
      dates: false
    },
    {
      text: "Nowe zamówienia biletów lotniczych",
      value: notificationTypes.FLIGHT_NEW_ORDER,
      dates: false
    },
    {
      text: "Nowe zamówienia biletów tanich lini lotniczych",
      value: notificationTypes.LOW_COST_NEW_ORDER,
      dates: false
    },
    {
      text: "Nowe zamówienia dot. ubezpieczeń",
      value: notificationTypes.INSURANCE_NEW_ORDER,
      dates: false
    },
    {
      text: "Pozostałe nowe zamówienia",
      value: notificationTypes.OTHER_NEW_ORDER,
      dates: false
    },
    {
      text: "Przypominaj o akcji do zrealizowania - wszystkie zamówienia",
      value: notificationTypes.ALL_REMIND_WNT,
      dates: true
    },
    {
      text: "Przypominaj o akcji do zrealizowania - zamówienia hotelowe",
      value: notificationTypes.HOTEL_REMIND_WNT,
      dates: true
    },
    {
      text: "Przypominaj o akcji do zrealizowania - zamówienia dot. wypożyczenia samochodu",
      value: notificationTypes.CAR_REMIND_WNT,
      dates: true
    },
    {
      text: "Przypominaj o akcji do zrealizowania - zamówienia biletów kolejowych",
      value: notificationTypes.RAIL_REMIND_WNT,
      dates: true
    },
    {
      text: "Przypominaj o akcji do zrealizowania - zamówienia biletów lotniczych",
      value: notificationTypes.FLIGHT_REMIND_WNT,
      dates: true
    },
    {
      text: "Przypominaj o akcji do zrealizowania - zamówienia biletów tanich lini lotniczych",
      value: notificationTypes.LOW_COST_REMIND_WNT,
      dates: true
    },
    {
      text: "Przypominaj o akcji do zrealizowania - zamówienia dot. ubezpieczeń",
      value: notificationTypes.INSURANCE_REMIND_WNT,
      dates: true
    },
    {
      text: "Przypominaj o akcji do zrealizowania - pozostałe zamówienia",
      value: notificationTypes.OTHER_REMIND_WNT,
      dates: true
    }
    // {text: 'Zatwierdzenie oferty przez klienta (wszystkie typy)', value: notificationTypes.ALL_CHOSEN_OFFER},
    // {text: 'Zatwierdzenie oferty hotelowej przez klienta', value: notificationTypes.HOTEL_CHOSEN_OFFER},
    // {text: 'Zatwierdzenie oferty wypożyczenia samochodu przez klienta', value: notificationTypes.CAR_CHOSEN_OFFER},
    // {text: 'Zatwierdzenie oferty biletów kolejowych przez klienta', value: notificationTypes.RAIL_CHOSEN_OFFER},
    // {text: 'Zatwierdzenie oferty biletów lotniczych przez klienta', value: notificationTypes.FLIGHT_CHOSEN_OFFER},
    // {text: 'Zatwierdzenie oferty innego typu przez klienta', value: notificationTypes.OTHER_CHOSEN_OFFER},
  ];
};
